import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './input.css'

const Input = ({ placeholder, optional, value, error, onChange }) => (
  <div styleName="container">
    <input
      onChange={onChange}
      placeholder={placeholder}
      styleName={error ? 'input-error' : 'input-normal'}
      type="text"
      value={value}
    />
    <div styleName={optional && !value ? 'optional-visible' : 'optional-hidden'}>
      Optional
    </div>
  </div>
)

Input.propTypes = {
  error: PropTypes.bool,
  onChange: PropTypes.func,
  optional: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
}

export default CSSModules(Input, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/input/input.js
 **/